import { render } from "./Track_Gallary.vue?vue&type=template&id=5f156f1e&scoped=true"
import script from "./Track_Gallary.vue?vue&type=script&lang=js"
export * from "./Track_Gallary.vue?vue&type=script&lang=js"

import "./Track_Gallary.vue?vue&type=style&index=0&id=5f156f1e&lang=scss&scoped=true"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f156f1e"]])

export default __exports__